// extracted by mini-css-extract-plugin
module.exports = {"headline":"headline-JhJZtMu_","tit_tag":"tit_tag-1M8tVEnj","tit_time":"tit_time-3_vf8drR","time":"time-y7TawK1J","num":"num-1HuIIubb"};